import React from 'react';
import { cn } from '../../lib/utils';

/**
 * OrkaSurface — canonical surface container (PRD §6.1).
 *
 * Replaces ad-hoc `bg-white border border-stone-200 rounded-2xl` spread
 * across pane/card/panel containers. All product surfaces should compose
 * from this rather than inline these classes.
 *
 *   <OrkaSurface variant="raised" radius="2xl">…</OrkaSurface>
 */
const VARIANT_CLASSES = {
  page: 'orka-surface-page',
  base: 'orka-surface-base',
  raised: 'orka-surface-raised orka-shadow-sm',  // shadow via tokens.css
  subtle: 'orka-surface-subtle',
  glass: 'orka-surface-glass',
  selected: 'orka-surface-selected',
  disabled: 'orka-surface-disabled opacity-60',
};

const RADIUS_CLASSES = {
  none: 'rounded-none',
  sm: 'rounded-md',
  md: 'rounded-lg',
  lg: 'rounded-xl',
  xl: 'rounded-2xl',
  full: 'rounded-full',
};

export function OrkaSurface({
  variant = 'base',
  radius = 'xl',
  bordered = true,
  as: Tag = 'div',
  className,
  children,
  ...rest
}) {
  return (
    <Tag
      className={cn(
        VARIANT_CLASSES[variant] || VARIANT_CLASSES.base,
        RADIUS_CLASSES[radius] || RADIUS_CLASSES.xl,
        bordered && 'border orka-border-subtle',
        className,
      )}
      style={{ boxShadow: variant === 'raised' ? 'var(--orka-shadow-sm)' : undefined, ...rest.style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default OrkaSurface;
